import {
  Page,
  LegacyCard,
  DataTable,
  Text,
  SkeletonDisplayText,
  BlockStack,
  Badge,
  Link,
} from "@shopify/polaris";
import { useGetOrderCountOfStaffQuery } from "../store/store/slices/StaffRTK";
import DateFilter from "../components/atoms/staff/DateFilter";
import { useState } from "react";
import { STAFF_TABLE_DATA_TYPES } from "../store/types/types";

export default function Staff() {
  const params = new URLSearchParams(window.location.search);
  const [activeDate, setActiveDate] = useState(null);
  const [selectedDate, setSelectedDate] = useState({
    start: params?.get("bookingfrom") || "",
    end: params?.get("bookingto") || "",
  });
  const { data, isLoading, isSuccess, isError, error, refetch } =
    useGetOrderCountOfStaffQuery(selectedDate);

  const rows = data?.stats
    ? data?.stats?.map((stat: STAFF_TABLE_DATA_TYPES) => [
        <Link removeUnderline url={`/dashboard/staff/${stat?.user_id}/stats`}>
          {stat?.user}
        </Link>,
        stat.role,
        stat.fulfilled_orders + stat.inprocess_orders + stat.delivered_orders,
        stat.cancelled_orders + stat.rts_orders,
        stat.total_orders,
      ])
    : [];
  const totalRow = data?.stats
    ? [
        "",
        "",
        data.stats.reduce(
          (total: number, stat: STAFF_TABLE_DATA_TYPES) =>
            total + stat.fulfilled_orders,
          0
        ) +
          data.stats.reduce(
            (total: number, stat: STAFF_TABLE_DATA_TYPES) =>
              total + stat.inprocess_orders,
            0
          ) +
          data.stats.reduce(
            (total: number, stat: STAFF_TABLE_DATA_TYPES) =>
              total + stat.delivered_orders,
            0
          ),
        data.stats.reduce(
          (total: number, stat: STAFF_TABLE_DATA_TYPES) =>
            total + stat.cancelled_orders,
          0
        ) +
          data.stats.reduce(
            (total: number, stat: STAFF_TABLE_DATA_TYPES) =>
              total + stat.rts_orders,
            0
          ),
        data.stats.reduce(
          (total: number, stat: STAFF_TABLE_DATA_TYPES) =>
            total + stat.total_orders,
          0
        ),
      ]
    : [];

  const onStaffFilterChangeHandler = async ({
    dates,
  }: {
    start: string;
    end: string;
  }) => {
    setSelectedDate(() => dates);
    setActiveDate(dates);
    refetch();
  };
  return (
    <Page title="Staff members" titleHidden>
      <BlockStack gap={"600"}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem 0px",
          }}
        >
          <Text as="h1" variant="headingLg">
            Staff members
          </Text>{" "}
          <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
            <Badge tone="info">
              {activeDate?.start?.toDateString()} -
              {activeDate?.end?.toDateString()}
            </Badge>
            <DateFilter onFilterChange={onStaffFilterChangeHandler} />
          </div>
        </div>
        <LegacyCard>
          {isLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                padding: "1rem",
              }}
            >
              <div>
                <SkeletonDisplayText size="small" maxWidth="100%" />
              </div>
              <div>
                <SkeletonDisplayText size="small" maxWidth="100%" />
              </div>
              <div>
                <SkeletonDisplayText size="small" maxWidth="100%" />
              </div>
              <div>
                <SkeletonDisplayText size="small" maxWidth="100%" />
              </div>
            </div>
          )}
          {!isError && !isLoading && isSuccess && (
            <DataTable
              columnContentTypes={[
                "text",
                "text",
                "numeric",
                "numeric",
                "numeric",
              ]}
              headings={[
                <Text as="span" fontWeight="bold">
                  Name
                </Text>,
                <Text as="span" fontWeight="bold">
                  Role
                </Text>,
                <Text as="span" fontWeight="bold">
                  Booked
                </Text>,
                <Text as="span" fontWeight="bold">
                  Cancelled
                </Text>,
                <Text as="span" fontWeight="bold">
                  Total
                </Text>,
              ]}
              rows={rows}
              totals={totalRow}
              showTotalsInFooter
            />
          )}
          {isError && (
            <>
              <p style={{ textAlign: "center", padding: "2rem" }}>
                {error?.data?.errors[0]?.msg ||
                  "Something went wrong. Please try again later"}
              </p>
            </>
          )}
        </LegacyCard>
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem 0px",
          }}
        >
          <Text as="h1" variant="headingLg">
            Comparison
          </Text>{" "}
        </div>
        <StaffChart chartAnalytics={data?.stats || []} /> */}
      </BlockStack>
    </Page>
  );
}
